import {Constants} from '../constants';

export class RouteUtil {

    /**
     * Returns true when the given router URL is under the dotcom area (/ux/dotcom/...).
     */
    static isDotcomRoute(url: string): boolean {
        return url.includes(`/${Constants.URL_BASE_DOTCOM}/`);
    }

    /**
     * Returns true when the given router URL is under the cart area (/ux/cart/...).
     */
    static isCartRoute(url: string): boolean {
        return url.includes(`/${Constants.URL_BASE_CART}/`);
    }

    /**
     * Returns true for paths that Angular's router can handle without a full page reload.
     * External (http/https) and hashbang (#) URLs return false and must use a plain href.
     */
    static isInternalUrl(url: string | null | undefined): boolean {
        if (!url) {
            return false;
        }
        if (url.startsWith('http') || url.includes('#')) {
            return false;
        }
        return url.includes(Constants.URL_BASE_CART) || url.includes(Constants.URL_BASE_DOTCOM);
    }
}
